type guideStartBannerType = {
    isShowGuideOnBanner: boolean,
};

export const guideStartBanner: guideStartBannerType = {
    isShowGuideOnBanner: false,
};
